<script setup>
import CFIcon from '@/ui/Icon/CFIcon.vue';

defineProps({
    label: {
        type: String,
        required: true,
    },
    icon: {
        /** @type import('vue').PropType<IconName> */
        type: String,
        required: true,
    },
    route: {
        type: Object,
        required: true,
    },
});
</script>

<template>
    <RouterLink
        v-slot="{ isActive }"
        :to="route"
        active-class="font-bold"
        class="flex items-center gap-3"
    >
        <CFIcon
            :name="icon"
            :variant="isActive ? 'bold' : 'light'"
            size="16"
        />

        {{ label }}
    </RouterLink>
</template>
